import SubHeader from "../../components/header/SubHeader";
import Button from "../../components/common/button/Button";
import Form from "../../components/common/form/Form";
import React, {useEffect} from "react";
import {useNavigate, useParams} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {getValidatedLimit} from "../../components/Utility";
import {fetchTagList} from "../../store/list-slice";
import {Role, Status} from "../../enums/enums";
import {getFormData} from "../../models/incomeProductModel";
import {fetchIncomeProductById, editIncomeProduct} from "../../store/income-product-slice";
import {incomeProductSchema} from "../../schema/incomeProductSchema";

const IncomeProductEdit = () => {
    const params = useParams();
    const incomeType = params.incomeType;
    const navigator = useNavigate();
    const dispatch = useDispatch();
    const {pagination} = useSelector(state => state.incomeProduct);
    const {limit, currentPage} = getValidatedLimit(pagination);

    const {
        items,
    } = useSelector(state => state.menu.transactionType);

    const {
        items:incomeProducts,
        editStatus,
        fetchByIdStatus,
        error
    } = useSelector(state => state.incomeProduct);

    const userRole = useSelector((state) => state.auth.selectedRole);
    const list = useSelector(state => state.list);

    const incomeTypeId = items.find(
        (item) => item.name.toLowerCase() === incomeType.toLowerCase()
    )?._id;

    useEffect(() => {
        dispatch(fetchIncomeProductById(
            {
                ...userRole,
                id: params.productId
            }
        ));
    }, [dispatch, params.productId, userRole]);

    const product = incomeProducts.find(item => item.id === params.productId);

    const updatedProduct = product
        ? {
            ...product,
            tags: product.tags.map(tagObj =>
                Object.values(tagObj).find(val => typeof val === 'string' && /^[a-f0-9]{24}$/i.test(val))
            ).filter(Boolean)
        }
        : null;  //


    useEffect(() => {
        if (editStatus === "success") {
            navigator(`../../?page=${currentPage}&limit=${limit}`);
        }
    }, [editStatus, navigator, currentPage, limit]);

    const formSubmitHandler = (data) => {
        const updatedData = {
            ...data,
            ttid: incomeTypeId
        }
        dispatch(editIncomeProduct(
            {
                ...userRole,
                data: updatedData,
                id: params.productId,
            }
        ));
    };

    const formCancelHandler = () => {
        navigator(`../../?page=${currentPage}&limit=${limit}`);
    };

    useEffect(() => {
        dispatch(fetchTagList(userRole));
    }, [dispatch, userRole]);

    const schema = incomeProductSchema({list, Status});
    if (userRole.role === Role.Manager) {
        delete schema.name;
        delete schema.image;
        delete schema.status;
        delete schema.description;
    } else if (userRole.scope === "Restaurant") {
        delete schema.availability
    }

    const initialData = getFormData(updatedProduct);
    return (
        <>
            <SubHeader title="Update Product">
                <Button to={`../../?page=${currentPage}&limit=${limit}`}
                        className="btn-sm bg-secondary bg-opacity-50">Back</Button>
            </SubHeader>
            <div className="container p-0 ms-0">
                <div className="row">
                    <div className="col-xl-6">
                        {fetchByIdStatus === "loading" && <p>Loading...</p>}
                        {fetchByIdStatus === "failed" && <h6 className="text-danger">{error}</h6>}
                        {fetchByIdStatus === "success" &&
                            <Form onFormSubmit={formSubmitHandler}
                                  onFormCancel={formCancelHandler}
                                  schema={schema}
                                  inline={false}
                                  initialData={initialData}
                                  status={editStatus}
                                  error={error}/>
                        }
                    </div>
                </div>
            </div>
        </>
    )
}

export default IncomeProductEdit;